import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	to: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.to',
		defaultMessage: 'to',
		description: 'label displayed between start and end times',
	},
});
